export default __webpack_public_path__ + "static/media/arrowLeft.a7b13250.svg";